module.exports = __webpack_public_path__ + "static/media/thermage_eyes.4a1830cf.svg";